//this action calls the POST signup, login and email subscribe API and then parses the dataFromAPI into a const function: subscribeSuccess, loginSuccess & signupSuccess. This action also GET user`s profile and parse the data into getProfileSuccess
import axios from 'axios';
import {
  API_BASE_URL,
  AUTH_COUNTRY_UPDATE,
  AUTH_CURRENCY_RATE_FETCH,
  AUTH_PROFILE_FETCH,
  AUTH_PROFILE_UPDATE,
  AUTH_REFRESH_TOKEN_FETCH,
  AUTH_SIGN_IN_POST,
  AUTH_SIGN_OUT,
  AUTH_SIGN_UP_POST,

  AUTH_SOCIAL_SIGN_IN,
  AUTH_SUBSCRIBE,
  AUTH_SUBSCRIBE_ERROR,
  // AUTH_SIGN_UP,
  // AUTH_LOGIN,
  // AUTH_PROFILES,
  AUTH_TOKEN_KEY,

  EMAIL_VERIFICATION,
  EMAIL_VERIFICATION_ERROR,

  EMAIL_VERIFICATION_LINK_SENT,
  EMAIL_VERIFICATION_SUBMIT,
  PROMISE_FULFILLED,
  SUBMIT_AUTH_SUBSCRIBE
} from '../constants/';
import fetch, { noReduxApi } from '../utils/Api';

const TOKEN = () => ({ Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY) })

export const doSignOut = () => ({
	type: AUTH_SIGN_OUT
})

export const doFetchProfile = () => ({
	type: AUTH_PROFILE_FETCH,
	payload: fetch({
		Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
	}).get('/auth')
		.then(response => response.data)
})

export const doFetchCurrencyRate = (currencyCode) => {
	if (currencyCode === "IDR") {
		return {
			type: `${AUTH_CURRENCY_RATE_FETCH}${PROMISE_FULFILLED}`,
			payload: {
				data: {
					ratio: 1,
					currency: "IDR"
				}

			}
		}
	}
	return {
		type: AUTH_CURRENCY_RATE_FETCH,
		payload: fetch({
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		}).get(`/currency_ratio/${currencyCode}`)
			.then(response => {
				return {
					data: {
						ratio: (response.data && response.data.data && response.data.data.ratio) ? response.data.data.ratio : 1,
						currency: currencyCode
					}

				}
			})
	}
}

export const doSentLinkVerificationEmail = () => ({
	type: EMAIL_VERIFICATION_LINK_SENT,
	payload: fetch({
		Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
	}).put('/users/email/verifications/link')
		.then(response => response.data)
})

export const doSignIn = ({ email, password, google_2fa }) => {
	let stringLower = email.toLowerCase()

	// if (isGmail(stringLower))
	// 	stringLower = `${stringLower.substring(0, stringLower.indexOf('@')).replace(dotRegex, '')}@gmail.com`;

	const payload = {
		email: stringLower,
		password,
		google_2fa
	}
	!google_2fa && delete payload.google_2fa
	return {
		type: AUTH_SIGN_IN_POST,
		payload: fetch().post('/auth', payload)
			.then(response => response.data)
	}
}

export const doSignUp = ({ email, password, seller_location_id }) => {
	let stringLower = email.toLowerCase()
	let real_email = stringLower;
	// if (isGmail(stringLower))
	// 	real_email = `${stringLower.substring(0, stringLower.indexOf('@')).replace(dotRegex, '')}@gmail.com`;
	return {
		type: AUTH_SIGN_UP_POST,
		payload: fetch().post('/auth/registrations', { email: real_email, password, typed_email: stringLower, seller_location_id })
			.then(response => response.data)
	}
}

export const doSocialSignIn = dataSocial => {
	let real_email = dataSocial.email.toLowerCase()

	!dataSocial.google_2fa && delete dataSocial.google_2fa
	return ({
		type: AUTH_SOCIAL_SIGN_IN,
		payload: fetch().post('/auth/social2', dataSocial)
			.then(response => response.data)
	})
}

export const doRefreshToken = () => ({
	type: AUTH_REFRESH_TOKEN_FETCH,
	payload: fetch({
		Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
	}).get('/auth/token/generate')
		.then(response => response.data)
})

export const subscribeSuccess = data => ({
	type: AUTH_SUBSCRIBE,
	payload: data
})

// export const loginSuccess = token => ({
// 	type:AUTH_LOGIN,
// 	payload:token
// })


// export const signupSuccess = data => ({
// 	type:AUTH_SIGN_UP,
// 	payload:data
// })

// export const getProfileSuccess = user => ({
// 	type:AUTH_PROFILES,
// 	payload:user
// })

const subscribeError = (err) => ({
	type: AUTH_SUBSCRIBE_ERROR,
	payload: err
})

const doPrepareSubscribeSubmit = (bool) => ({
	type: SUBMIT_AUTH_SUBSCRIBE,
	payload: bool
})

export const doSubscribe = email => {
	return dispatch => {
		dispatch(doPrepareSubscribeSubmit(true));
		axios.post(`${API_BASE_URL}/subscribers`, email)
			.then((res) => {
				dispatch(subscribeSuccess(res.data));
				dispatch(doPrepareSubscribeSubmit(false));
			})
			.catch((err) => {
				dispatch(subscribeError(err));
				dispatch(doPrepareSubscribeSubmit(false));
			})
	}
}

// export const doSignUp = emailAndPasswordSignUP => {
// 	return dispatch =>(
// 		axios.post(`${API_BASE_URL}/auth/registrations`,emailAndPasswordSignUP)
// 		.then((res)=>(dispatch(signupSuccess(res.data))))
// 		.catch((err)=>(dispatch(signupSuccess(err))))
// 	)
// }

// export const doLogin = emailAndPasswordLogin => {
// 	return dispatch=>(
// 		axios.post(`${API_BASE_URL}/auth`,emailAndPasswordLogin)
// 		.then(res =>{
// 			dispatch(loginSuccess(res.data.data))
// 		})
// 	)
// }


export const doGetProfile = () => {
	let instance = axios.create({
		baseURL: API_BASE_URL,
		headers: {
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		}
	})
	return dispatch => (
		instance.get('/auth')
			.then((res) => dispatch(doGetProfile(res.data.data)))
	)
}
const doPrepareSubmit = (bool) => ({
	type: EMAIL_VERIFICATION_SUBMIT,
	payload: bool
})
const doGetEmailVerify = (payload) => ({
	type: EMAIL_VERIFICATION,
	payload: payload
})
const doErrorEmailVerification = (err) => ({
	type: EMAIL_VERIFICATION_ERROR,
	payload: err
})
export const doEmailVerification = (payload) => {
	return dispatch => (
		dispatch(doPrepareSubmit(true)),
		axios.put(`${API_BASE_URL}/users/email/verify/${payload.token}`, { email: payload.email })
			.then((res) => {
				dispatch(doGetEmailVerify(res.data));
				dispatch(doPrepareSubmit(false));
			})
			.catch(err => {
				dispatch(doErrorEmailVerification(err));
				dispatch(doPrepareSubmit(false));
			})
	)
}

export const doUpdateProfile = (dataProfile) => {
	return ({
		type: AUTH_PROFILE_UPDATE,
		payload: fetch({
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		})
			.put('/auth/update', dataProfile)
			.then(response => response.data)
	})
}

export const doUpdateUserProfile = (dataProfile) => {
	return ({
		type: AUTH_PROFILE_UPDATE,
		payload: fetch({
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		})
			.put('/users', dataProfile)
			.then(response => response.data)
	})
}

export const updateUserCountry = (data) => {
	return ({
		type: AUTH_COUNTRY_UPDATE,
		payload: fetch({
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		})
			.put('users/country', data)
			.then(response => response.data)
	})
}

export const doHolidayMode = (bool) => {
	return {
		type: "TOGGLE_HOLIDAY_MODE",
		payload: new Promise((res, rej) => {
			res({ is_holiday: bool })
		}).then(data => ({ data: { is_holiday: bool }, status_code: 200, message: 'Toggled...' }))
	}
}
//   dispatch => (
//     axios.put(`${API_BASE_URL}/users`,dataProfile)
//       .then(res => {
//         dispatch({type: AUTH_PROFILE_UPDATE, payload: res.data})
//       })
//       .catch(err => {
//         dispatch({type: AUTH_PROFILE_UPDATE, payload: err})
//       })
//   )
// )

// export const getOtp = () => {
// 	return axios.post(`${API_BASE_URL}/auth/otp`, {}, {
// 		headers: {
// 			'Content-Type': 'application/json',
// 			'Authorization': 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
// 		}
// 	})
// 		.then(response => {
// 			return { success: true }
// 		})
// 		.catch(error => {
// 			console.log("error when getting otp code")

// 			const _error = error?.toJSON() ?? {}
// 			console.log(_error, "_error____")
// 			return { error: _error?.message ?? "Failed to get otp code" }
// 		})
// }
export const getOtp = () => {
	return ({
		type: "GET_OTP_CODE",
		payload: fetch({
			Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY)
		})
			.post('auth/otp')
			.then(response => response.data)
	})
}

export const resetOtpState = () => {
	return ({
		type: "GET_OTP_CODE_RESET",
		payload: null
	})
}

export const getOtpStatus = () => ({
	type: "GET_OTP_STATUS",
	payload: fetch()
		.get("settings?keyword=otp_status")
		.then(res => {
			const data = res?.data?.data?.data?.[0]?.value ?? {}
			return data
		})
});

export const getPopupBanner = (keyword = "") => {
  return noReduxApi(TOKEN()).get(`/popup_banners?keyword=${keyword}`)
}